import React from 'react';
import {
  Fade,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import Zoom from '@mui/material/Zoom';
import {
  BarChart as BarChartIcon,
  LocationOn as LocationOnIcon,
} from '@mui/icons-material';
import Chart from 'react-apexcharts';

const SchoolsTab = ({ data = {} }) => (
  <Fade in timeout={500}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Card
          sx={{
            p: 3,
            boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
            borderRadius: 2,
            transition: 'all 0.3s ease-in-out',
            '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
          }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, p: 2, bgcolor: 'success.lighter', borderRadius: 1 }}>
              <BarChartIcon sx={{ mr: 1, color: 'success.main' }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                School Distribution by Users
              </Typography>
            </Box>
            <CardContent sx={{ p: 3, pt: 0 }}>
              <Chart
                options={{
                  chart: {
                    type: 'bar',
                    animations: { enabled: true, easing: 'easeinout', speed: 800 },
                  },
                  xaxis: {
                    categories: data?.distribution?.map((school) => school.name) || [],
                    labels: {
                      style: { fontSize: '12px', fontWeight: 500 },
                      rotate: -45,
                    },
                  },
                  yaxis: {
                    title: {
                      text: 'Number of Users',
                      style: { fontSize: '14px', fontWeight: 600 },
                    },
                  },
                  colors: ['#1976d2', '#2e7d32', '#f57c00', '#9c27b0', '#d32f2f'],
                  dataLabels: {
                    enabled: true,
                    style: { fontSize: '12px', fontWeight: 'bold' },
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '60%',
                      borderRadius: 4,
                    },
                  },
                  legend: { show: false },
                }}
                series={[
                  {
                    name: 'Total Users',
                    data: data?.distribution?.map((school) => school.totalUsers) || [],
                  },
                ]}
                type="bar"
                height={400}
              />
            </CardContent>
          </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            p: 3,
            boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
            borderRadius: 2,
            transition: 'all 0.3s ease-in-out',
            '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
            display: 'flex',
            flexDirection: 'column',
            height: '540px', // Match chart card height (header + chart height + padding)
          }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 5, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <LocationOnIcon sx={{ mr: 1, color: 'info.main' }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                Schools Details
              </Typography>
            </Box>
            <CardContent sx={{ p: 3, pt: 0, flex: 1, overflowY: 'auto', minHeight: 0 }}>
              {data?.distribution?.map((school, index) => (
                <Zoom in timeout={300 + index * 100} key={school.name ?? index}>
                  <Paper
                    sx={{
                      p: 2,
                      mb: 2,
                      boxShadow: 1,
                      borderRadius: 2,
                      transition: 'all 0.3s ease-in-out',
                      '&:hover': {
                        boxShadow: 3,
                        transform: 'translateX(4px)',
                        borderLeft: '4px solid #1976d2',
                      },
                      border: '1px solid',
                      borderColor: 'grey.200',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        color: '#1976d2 !important',
                        fontSize: '0.9rem',
                      }}
                    >
                      {school.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mb: 1,
                        textTransform: 'capitalize',
                        color: '#666666 !important',
                        fontSize: '0.8rem',
                      }}
                    >
                      {school.state}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: '#333333 !important', fontSize: '0.8rem' }}
                      >
                        Total:{' '}
                        <span style={{ color: '#1976d2', fontWeight: 'bold' }}>
                          {school.totalUsers}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: '#333333 !important', fontSize: '0.8rem' }}
                      >
                        Teachers:{' '}
                        <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                          {school.teachers}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: '#333333 !important', fontSize: '0.8rem' }}
                      >
                        Edifiers:{' '}
                        <span style={{ color: '#ed6c02', fontWeight: 'bold' }}>
                          {school.edifiers}
                        </span>
                      </Typography>
                    </Box>
                  </Paper>
                </Zoom>
              ))}
            </CardContent>
          </Card>
      </Grid>
    </Grid>
  </Fade>
);

export default SchoolsTab;

